<template>
  <f7-panel left cover>
    <f7-view>
      <f7-page name="panel-left" class="bg-color-white" >
        <f7-toolbar v-if="IS_LOGGED_IN && UserInfo && isCreditsDisplayed" bottom >
          <div class="row width-100">
              <f7-link href="/credits/recharge/" view=".view-main" class="col panel-close">{{ $t('Remaining', {r: UserInfo.SMSTimes}) }}</f7-link>
          </div>

        </f7-toolbar>

        <f7-block class="bg-header no-margin padding-vertical">
          <img :src=" logo " class="logo" alt="">
          <template v-if="IS_LOGGED_IN && UserInfo">
            <p class="text-color-white no-margin-bottom margin-top">{{UserInfo.FirstName}} {{UserInfo.SurName}}</p>
            <p class="text-color-gray no-margin-top">{{UserInfo.Email}}</p>
          </template>
          <span class="app-version text-color-gray">v{{AppVersion}}</span>
        </f7-block>
        <f7-list no-chevron no-hairlines no-hairlines-between>
          <f7-list-item link="/dashboard/" view=".view-main" :title="$t('Dashboard')" back force panel-close>
            <template #media>
              <f7-icon icon="f7-icons icon-dashboard text-color-lightgray"></f7-icon>
            </template>
          </f7-list-item>
          <f7-list-item link="/assets/" view=".view-main" :title="$t('Assets')" panel-close>
            <template #media>
              <f7-icon icon="f7-icons icon-assets text-color-lightgray"></f7-icon>
            </template>
          </f7-list-item>
          <f7-list-item link="/customers/" view=".view-main" :title="$t('Customers')" panel-close>
            <template #media>
              <f7-icon icon="f7-icons icon-customers text-color-lightgray"></f7-icon>
            </template>
          </f7-list-item>
          <f7-list-item link="/user-settings/" view=".view-main" :title="$t('UserSettings')" panel-close>
            <template #media>
              <f7-icon icon="f7-icons icon-asset-details text-color-lightgray"></f7-icon>
            </template>
          </f7-list-item>
          <f7-list-item :link="supportUrl" :title="$t('Support')" panel-close external target="_blank">
            <template #media>
              <f7-icon icon="f7-icons icon-details text-color-lightgray"></f7-icon>
            </template>
          </f7-list-item>
          <f7-list-item link="#" :title="$t('Logout')" @click="logout" panel-close class="">
            <template #media>
              <f7-icon icon="f7-icons icon-logout text-color-lightgray"></f7-icon>
            </template>
          </f7-list-item>

        </f7-list>
      </f7-page>
    </f7-view>
  </f7-panel>
</template>


<script>

import {f7, theme} from 'framework7-vue';
import {mapGetters} from "vuex";
import {ApiMethods} from "../services/qt-api";

export default {
  name: "panel-left",


  data() {
    return {
      logo: 'static/images/logo.svg',
      isCreditsDisplayed: false,
    }
  },

  computed: {
    ...mapGetters(['IS_LOGGED_IN', 'UserInfo', 'AppVersion', 'MajorToken', 'MinorToken']),
    supportUrl(){
      //console.log(ApiMethods.GO_FOR_SUPPORT)
      return ApiMethods.GO_FOR_SUPPORT + '?' + f7.utils.serializeObject({ MajorToken: this.MajorToken, MinorToken: this.MinorToken })
    }
  },

  async mounted() {
    let additionalFlags = await this.$store.dispatch('getFromStorage', 'additionalFlags')
    //console.log(additionalFlags)
    this.isCreditsDisplayed = !theme.ios ? true : !!additionalFlags?.elemRc
  },

  methods: {
    logout(){
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style scoped>

</style>